<template>
    <nav v-if="items && items.length" class="triggers" :class="{ border }">
        <button 
            v-for="(item, key) in items" 
            :key="key" 
            :class="{ active: value == key }"
            @click="$emit('select', item)"
        >{{item.title || item[title]}}</button>
    </nav>
</template>

<script>
export default {
    props: {
        items: Array,
        value: [Number, String],
        title: String,
        border: {
            default: true,
            type: Boolean
        }
    },
    emits: ['select']
}
</script>

<style scoped lang="scss">
@import '@/styles/mixins.scss';
@import '@/styles/variables.scss';

.triggers {
    position: relative;
    button {
        @include reset();
        height: auto;
        height: 32px;
        line-height: 1.5;
        margin: 0;
        position: relative;
        font-size: 14px;
        font-weight: 600;
        color: var(--base-link);
        border-bottom: 3px solid var(--base-link);
        margin-right: 1rem;
        &:focus,
        &:hover,
        &.active {
            color: var(--text-color);
            border-bottom-color: var(--text-color);
        }
    }
    &.border::before {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 3px;
		background: var(--base-light-alternative-color);
		opacity: 0.5;
    }
}
</style>
